import { useMemo } from 'react';
import { usePermissions } from 'react-admin';
import { DashboardWrapper } from '../../components';
import { PERMISSIONS } from '../../constants';
import useDashboardContext from '../../hooks/useDashboardContext';
import { formatCpf, formatPoints } from '../../utils';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

const RANK_CUSTOMERS_LIMIT = 5;

const tableSx = {
  minWidth: 280,
};

const tableRowSx = {
  textDecoration: 'none',
};

export const RankCustomersAddedPoints = () => {
  const { permissions } = usePermissions();
  // Usa dados do contexto (carregado pelo AditionPointsChart)
  const { pointsSummaryData, pointsSummaryLoading } = useDashboardContext();

  // Deriva customersData do contexto
  const customersData = useMemo(() => {
    if (!pointsSummaryData?.topCustomers) return null;

    return pointsSummaryData.topCustomers
      .slice(0, RANK_CUSTOMERS_LIMIT)
      .map((c, index) => ({
        ...c,
        rank: index + 1,
      }));
  }, [pointsSummaryData]);

  return (
    <DashboardWrapper
      permission={PERMISSIONS.RANK_CUSTOMERS_ADDED_POINTS}
      title='Ranking Pontos Adicionados'
      width='50%'
      loading={!pointsSummaryData && pointsSummaryLoading}
      content={
        <TableContainer>
          <Table sx={tableSx} aria-label="customized table">
            <TableBody>
              {customersData
                ? customersData.map(c => (
                  <TableRow
                    sx={tableRowSx}
                    key={c.id} hover>
                    <TableCell>{c.rank}</TableCell>
                    <TableCell >{formatCpf(c.id)}</TableCell>
                    <TableCell align="right">{formatPoints(c.totalPoints)}</TableCell>
                  </TableRow>
                )) : null}
            </TableBody>
          </Table>
        </TableContainer>
      }
    />
  )
}
